import React from 'react';

import classNames from 'classnames';
import { CrossIcon } from 'components/CommonIcons';
import Checkbox from '../../../Checkbox';
import * as styles from './AddColumnsHeaderRowMenu.scss';

const AddColumnsHeaderRowMenu = (props) => {
  const { allColumns, selectedColumns, toggleColumn, hideColumnMenu } = props;
  const isUncheckColumnEnable = selectedColumns.length >= 4;

  const checkboxToggle = (columnData, isChecked) => {
    if (isUncheckColumnEnable || !isChecked) {
      toggleColumn(columnData.dataKey);
    }
  };

  return (
    <div className={styles.headerMenuContainer}>
      <div className={styles.remainingFilters}>
          {`${6 - selectedColumns.length} remaining (3 min - 6 max)`}
      </div>
      <div
        className={styles.closeIconContainer}
        onClick={hideColumnMenu}>
        <CrossIcon />
      </div>
      <div>
        {allColumns.map((columnData) => {
          const isChecked = selectedColumns.findIndex(x => x.dataKey === columnData.dataKey) !== -1;
          const isDisabled = selectedColumns.length === 6 && !isChecked;
          return (
            <div
              className={styles.columnFilterSelection}
              key={`${columnData.dataKey}`}>
              <Checkbox
                onChange={() => { checkboxToggle(columnData, isChecked); }}
                checked={isChecked}
                disabled={isDisabled}
                text={columnData.label} />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AddColumnsHeaderRowMenu;
